import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/* Util */
import { isEmptyObj } from 'app/utils/util';

/* Interfaces */
import { ParamOptions } from 'app/shared/interfaces-types/TParamOptions';
import { Grupos, Usuario } from 'app/shared/models/groups/groups';

interface IParams {
  prop: string;
  value: any;
}

export class GenericRequestProvider<T> {

  private params = {} as ParamOptions<T>;
  public URI = null;

  constructor(public path: string, public http: HttpClient) {
    this.URI = process.env.APIURL;
  }

  setParams({ prop, value }: IParams) {
    this.params[prop] = value;
  }

  public get(
    param?: ParamOptions<T>,
    newUri?: string,
    paramExtra?: string
  ): Observable<T> {
    let parameters = '';

    if (!isEmptyObj(param)) {
      parameters = this.generateParams(param);
    } else if (!isEmptyObj(this.params)) {
      parameters = this.generateParams(this.params);
    }

    if (paramExtra != null) {
      if (parameters == '') {
        parameters = paramExtra;
      } else {
        parameters = parameters + '&' + paramExtra;
      }
    }

    let pathComplete = `${this.URI}${this.path}${parameters}`;
    let pipeMap = (res: any) => res.data;

    if (newUri != null) {
      pathComplete = `${newUri}${this.path}${parameters}`;
      pipeMap = (res: any) => res.data;
    }

    return this.http.get<T>(pathComplete).pipe(map(pipeMap));
  }

  public getBinary(param?: ParamOptions<T>, newUri?: string): Observable<any> {
    let parameters = '';

    if (!isEmptyObj(param)) {
      parameters = this.generateParams(param);
    } else if (!isEmptyObj(this.params)) {
      parameters = this.generateParams(this.params);
    }

    let pathComplete = `${this.URI}${this.path}${parameters}`;

    if (newUri != null) {
      pathComplete = `${newUri}${this.path}${parameters}`;
    }

    return this.http.get(pathComplete, { responseType: 'arraybuffer' });
  }

  getAll(param?: ParamOptions<T>): Observable<T[]> {
    let parameters = '';

    if (!isEmptyObj(param)) {
      parameters = this.generateParams(param);
    }

    return this.http
      .get<T[]>(`${this.URI}${this.path}${parameters}`)
      .pipe(map((res: any) => res.data));
  }

  public getById(id: number): Observable<any[]> {
    return this.http
      .get<T>(`${this.URI}${this.path}/${id}`)
      .pipe(map((res: any) => res.data));
  }

  public getListById(id: number): Observable<T[]> {
    return this.http
      .get<T>(`${this.URI}${this.path}/${id}`)
      .pipe(map((res: any) => res.data));
  }

  public post(model?: Object): Observable<T> {
    return this.http.post<T>(`${this.URI}${this.path}`, model);
    // .pipe(
    //     map((res: any) => res));
  }

  public postFormData(formData?: FormData): Observable<T> {
    return this.http
      .post<T>(`${this.URI}${this.path}`, formData)
      .pipe(map((res: any) => res.data));
  }

  public put(id: number | string, body: Object): Observable<T> {
    if (!id) {
      id = '';
    }
    return this.http
      .put<T>(`${this.URI}${this.path}/${id}`, body)
      .pipe(map((res: any) => res));
  }

  public delete(id: number): Observable<T> {
    return this.http.delete<T>(`${this.URI}${this.path}/${id}`);
  }
  public filtroUsers(param: any): Observable<Usuario> {
    return this.http
      .get<Usuario>(`${this.URI}${this.path}=${param}`)
      .pipe(map((res: any) => res.data.usuarios));
  }
  public filtroUsersGrupoId(param: any, paramID: number): Observable<Usuario> {
    return this.http
      .get<Usuario>(`${this.URI}${this.path}=${param}&GrupoId=${paramID}`)
      .pipe(map((res: any) => res.data.usuarios));
  }
  public filtroGrupos(param: any): Observable<Grupos> {
    return this.http
      .get<Grupos>(`${this.URI}${this.path}=${param}`)
      .pipe(map((res: any) => res.data.grupos));
  }

  private generateParams(obj: ParamOptions<T>): string {
    let queryString = '?';
    let it = 0;
    // tslint:disable-next-line:forin
    for (const key in obj) {
      if (it > 0) {
        queryString += '&';
      }
      queryString += `${key}=${obj[key]}`;
      it++;
    }
    if (queryString.length === 1) {
      queryString = '';
    }
    return queryString;
  }
  public getListObj(param?: ParamOptions<T>,newUri?: string, paramExtra?: string): Observable<T> {
    let parameters = "";

    if (!isEmptyObj(param)) {
      parameters = this.generateParams(param);
    }
    if (paramExtra != null) {
      if (parameters == "") {
        parameters = paramExtra;
      } else {
        parameters = parameters + "&" + paramExtra;
      }
    }
    return this.http
      .get<T>(`${this.URI}${this.path}${parameters}`)
      .pipe(map((res: any) => res));
  }
 
  
}

